// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__DNCff","logo":"style_logo__-bbmh"};